import { styled, css } from 'styled-components';

import Chevron from '@src/components/atoms/action/chevron';

const UnstyledButton = styled.button`
  padding: 0;
  font: inherit;
  appearance: none;
  background: none;
  border: none;
  text-align: inherit;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  padding-inline: 16px;
  padding-block: 8px;
  align-items: center;
`;

export const wrapperStyles = css<{ $isQuiet?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #212322;
  background-color: #fff;
  text-align: left;

  &:hover:not(:disabled) {
    background-color: #f4f4f4;
  }

  ${Chevron} {
    display: block;
    justify-self: end;
    aspect-ratio: 12 / 13;
    height: 12px;
    width: auto;

    path {
      vector-effect: non-scaling-stroke;
    }
  }

  ${({ $isQuiet }) =>
    !$isQuiet &&
    css`
      border-radius: 8px;
      border: 1px solid #dedddb;
    `}

  @media screen and (min-width: 768px) {
    ${Chevron} {
      height: 16px;
    }
  }
`;

export const LinkWrapper = styled.a<{ $isQuiet?: boolean }>`
  ${wrapperStyles}
`;
export const ButtonWrapper = styled(UnstyledButton)<{ $isQuiet?: boolean }>`
  ${wrapperStyles}
`;
export const Wrapper = styled.div<{ $isQuiet?: boolean }>`
  ${wrapperStyles}
`;

export const Content = styled.div`
  flex: 1 1 auto;
`;

export const Heading = styled.div`
  font: 500 16px / 20px var(--font-family-founders-grotesk);
`;

export const Text = styled.div`
  font: 400 16px / 20px var(--font-family-founders-grotesk);
`;

export const ImageWrapper = styled.div`
  height: 60px;
  width: 60px;
  flex: 0 0 auto;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;

  @media screen and (min-width: 375px) {
    width: 110px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
